import { createContext, useContext } from "react";

export type Tokens = {
  accessToken: string;
  refreshToken: string;
};

export type AuthenticationState = "BOOTING" | "SIGNED_OUT" | "SIGNED_IN";

export type Role = "admin" | "praxis";

export type Account = {
  id: string;
  username: string;
  role: Role;
  praxisSubdomain: string | null;
};

export type SignUpInterface = {
  firstName: string;
  email: string;
  password: string;
};

export type Authenticator = {
  login(email: string, password: string, rememberMe: boolean): Promise<void>;
  signOut(): Promise<void>;
  state: "SIGNED_IN" | "SIGNED_OUT" | "BOOTING";
  /** Set while signed in */
  account: Account | null;
};

export const AuthenticationContext = createContext<
  Readonly<Authenticator> | undefined
>(undefined);

export const AuthenticationProvider = AuthenticationContext.Provider;

export function useAuth(): Authenticator {
  const auth = useContext(AuthenticationContext);

  if (!auth) {
    throw new Error(
      `The component that calls useAuthentication() needs to be a deep child of <AuthenticationProvider>`,
    );
  }

  return auth;
}
